import type { FetchError } from '@execonline-inc/fetch.private';
import type { UseFetch } from '@execonline-inc/react-hooks.private';
import { currentUserStore } from '../../../../../CurrentUserStore';
import { useFetchResource, useFindLinkByR } from '../../../../../Fetch';
import { declareEndpoint, type MissingLinkError } from '../../../../../Links';
import * as Resourceable from '../../../../../Resourceable';

// DVLP-7601: fetch the collection payload for the admin preview. Returns the
// same shape as `edit-learning-collection-template-v2` so downstream v2
// Builder components render it unchanged. The simulated PLT is applied
// client-side via `entitledExperienceIds` in PreviewLicenseContext, so this
// fetch runs once per collection load — no refetch on PLT changes.

export type State = UseFetch.State<
  FetchError | MissingLinkError,
  Resourceable.ParsedResponse<'/learning_collection_preview/:id', 'get'>
>;

interface UsePreviewBuilderResult {
  state: State;
}

export const usePreviewBuilder = (id: string): UsePreviewBuilderResult => {
  const link = useFindLinkByR(
    { rel: 'preview-learning-collection-payload-v2', method: 'get' },
    currentUserStore.links,
  );

  const state = useFetchResource(
    link
      .map((l) => ({ ...l, href: l.href.replace(`{learning_collection_id}`, `${id}`) }))
      .map(declareEndpoint('/learning_collection_preview/:id')),
  );

  return { state };
};
